import { render } from "./exchangeNaive.vue?vue&type=template&id=2bbd05ac&scoped=true&lang=pug"
import script from "./exchangeNaive.vue?vue&type=script&setup=true&lang=js"
export * from "./exchangeNaive.vue?vue&type=script&setup=true&lang=js"

import "./exchangeNaive.vue?vue&type=style&index=0&id=2bbd05ac&scoped=true&lang=css"

import exportComponent from "/Users/liu/Downloads/cross-bridge v0.1.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2bbd05ac"]])

export default __exports__